import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators  } from '@angular/forms';
import { ApisService } from 'src/app/service/APIs/apis.service';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { environment } from 'src/environments/environment';
import { Country, State, City }  from 'country-state-city';

@Component({
  selector: 'app-become-agent',
  templateUrl: './become-agent.component.html',
  styleUrls: ['./become-agent.component.scss']
})
export class BecomeAgentComponent implements OnInit {

  public agentForm: FormGroup | any | undefined;

  public countries: any;


  baseUrl = environment.baseUrl
  constructor(
    private apiService: ApisService,
    private formBuilder: FormBuilder,
    private alert: AlertServiceService) { }

  registerAgent(){
    // console.log('testing if it got it', this.agentForm.value);
    this.alert.showLoading();
    if (this.agentForm.valid != true) {
      this.alert.errorPop('Either Email, Phone number, Business name, No of Pos Required is invalid, kindly Check');
      return;
    }
    let data: any = {
      firstName: this.agentForm.value.firstName,
      lastName: this.agentForm.value.lastName,
      email: this.agentForm.value.email,
      phoneNumber: this.agentForm.value.phoneNumber,
      businessName: this.agentForm.value.businessName,
      address: this.agentForm.value.address,
      residentialAddress: this.agentForm.value.residentialAddress,
      noPosReq: parseInt(this.agentForm.value.noPosReq)
    }

      // console.log('data', data);


    this.apiService.becomeAgent(data)
    .subscribe({
      next: (data: any) => {
        // console.log('response', data);
        this.alert.successPop(data?.message);

      },
      error: (err) => {
        // console.log("error", err);
        this.alert.errorPop('Either Email, Phone number, Business name, website already taken, kindly Check');
    }
    });

  }

  /**get all the countries */
  getCountries(){
    this.apiService.getCountry()
    .subscribe({
      next: (data: any) => {
        // console.log('response', data);
        this.countries = data;
      },
      // error: (err) => console.log("error", err)
    })
  }

  ngOnInit(): void {

    // console.log('all countries', Country.getAllCountries());
    this.countries = Country.getAllCountries();

    // this.getCountries();

    this.agentForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      businessName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      residentialAddress: ['', [Validators.required]],
      noPosReq: [1, [Validators.required]],
    });
  }


}
